import React, { useRef } from 'react';
import { Route, Routes } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import InstantChecksPage from './pages/InstantChecksPage';
import BackgroundChecksPage from './pages/BackgroundChecksPage';
import DueDiligencePage from './pages/DueDiligencePage';
import ContactUsButtonComponent from './components/ContactUsButtonComponent';
import SalesPage from './pages/SalesPage';
import MarketingPage from './pages/MarketingPage';
import FinancePage from './pages/FinancePage';
import HRPage from './pages/HRPage';
import ProcurementPage from './pages/ProcurementPage';
import ProjectManagementPage from './pages/ProjectManagementPage';
import ContactUsPage from './pages/ContactUsPage';
import AboutUsPage from './pages/AboutUsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import CareerPage from './pages/CareerPage';


function App() {
  const departmentsRef = useRef(null);
  const solutionsRef = useRef(null);
  const resourcesRef = useRef(null);
  const aboutRef = useRef(null);
  return (
      <>
        <Header 
        departmentsRef={departmentsRef} 
        solutionsRef={solutionsRef} 
        resourcesRef={resourcesRef} 
        aboutRef={aboutRef} 
      />
      <Routes>
      <Route 
          path="/" 
          element={
            <HomePage 
              departmentsRef={departmentsRef} 
              solutionsRef={solutionsRef}
              resourcesRef={resourcesRef}
              aboutRef={aboutRef} 
            />
          }
        />
        <Route path="/instant-checks" element={<InstantChecksPage />} />
        <Route path="/background-checks" element={<BackgroundChecksPage />} />
        <Route path="/due-diligence" element={<DueDiligencePage />} />
        <Route path="/sales" element={<SalesPage />} />
        <Route path="/marketing" element={<MarketingPage />} />
        <Route path="/hr" element={<HRPage />} />
        <Route path="/finance" element={<FinancePage />} />
        <Route path="/procurement" element={<ProcurementPage />} />
        <Route path="/project-management" element={<ProjectManagementPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/about-us" element={< AboutUsPage/>} />
        <Route path="/privacy-policy" element={< PrivacyPolicyPage/>} />
        <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
        <Route path="/careers-form" element={<CareerPage />} />
        

        </Routes>
        <Footer/>
        <ContactUsButtonComponent />

      </>
  );
}

export default App;
